<template>
  <Layout>
    <template v-if="tabShow">
      <el-tabs v-model="activeTab" :class="[mode !== '' ? isEdit : '']" stretch type="border-card" class="isStyleBase">
        <el-tab-pane v-for="(tab, index) in tabList" :key="index" :label="tab.title" :name="`${index}`" class="AVD">
        </el-tab-pane>
      </el-tabs>
    </template>
    <template v-if="tabShow">
      <div :class="{ [$style.marginContent]: tabList[activeTab].type !== 'spa' }">
        <component :is="tabList[activeTab].component" :merchant-products="products" :service-category="category"
          @update-category="updateCategory" @update-mode="updateMode" @changeTitle="changeTitle"
          @closeTabAndOpenInventoryDetail="closeTabAndOpenInventoryDetail">
        </component>
      </div>
    </template>
    <template v-if="!tabShow">
      <InventoryHistoryDetail :history-detail="historyDetail" @toTabShow="tabShow = true" />
    </template>
  </Layout>
</template>

<script>
import lazyLoadComponent from '@router/lazyload-component'

import Layout from '@layouts/main'
import BaseButtonDialog from '@components/BaseButtonDialog'

import pageMixin from '@src/mixins/pagination'

import { productTypeList, productTypeFilter, prepaidCapacityFilter, priceStatusFilter } from '@utils/filter-value-to-text'
import { formatDateRange } from '@utils/format-date'
import { getSavedState } from '@utils/browser-help'

export default {
  page: {
    title: '商品管理',
    meta: [{ name: 'description', content: 'Prices List' }],
  },
  components: {
    Layout,
    BaseButtonDialog,
    BaseStateLabel: () => lazyLoadComponent(import('@components/BaseStateLabel')),
    InventoryHistoryDetail: () => lazyLoadComponent(import('./components/InventoryHistoryDetail')),
  },
  filters: {
    productTypeFilter,
    priceStatusFilter,
    prepaidCapacityFilter,
    formatDateRange,
  },
  mixins: [pageMixin],
  props: {
    merchantProducts: {
      type: Array,
      required: true,
    },
    serviceCategory: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      products: [...this.merchantProducts],
      category: [...this.serviceCategory],
      filterData: {
        state: '',
        productId: '',
        type: '',
      },
      historyDetail: {}, // 歷史詳細資料
      productTypeList: Object.freeze(productTypeList),
      activeTab: this.$route.params.activeTab || '1',
      tabList: Object.freeze([
        {
          title: '基本設定',
          type: 'basic',
          component: () => lazyLoadComponent(import('./TabBasic')),
        },
        {
          title: '商品分類',
          type: 'categories',
          component: () => lazyLoadComponent(import('./TabCategories')),
        },
        {
          title: '商品管理',
          type: 'commodityManage',
          component: () => lazyLoadComponent(import('./TabCommodityManage')),
        },
        {
          title: `庫存管理`,
          type: 'inventoryManagement',
          component: () => lazyLoadComponent(import('./TabInventoryManagement')),
        },

      ]),
      mode: '',
      tabShow: true, // 預設就顯示tab
    }
  },
  computed: {
    pageTitle() {
      return this.mode ? (this.mode === 'add' ? `新增${this.tabList[+this.activeTab].title}` : `編輯${this.tabList[+this.activeTab].title}`) : `服務項目`
    },
  },
  watch: {},
  created() {
    const activeTabIndex = this.tabList.findIndex((item) => item.type === this.$route.params.type)
    this.activeTab = activeTabIndex > -1 ? `${activeTabIndex}` : `0`
    if (this.$route.query.tab === 'category') {
      this.activeTab = '2'
    }
    this.filterTabList()
  },
  methods: {
    /**
     * @description 關閉tab & 開啟庫存紀錄
     */
    async closeTabAndOpenInventoryDetail(row) {
      try {
        const { items } = await this.$store.dispatch('inventory/inventoryHistoryDetail', { id: row.id })
        this.historyDetail = items
        this.tabShow = false
      } catch (error) {
        console.error(error.message)
      }

    },
    /**
     * @description 如果沒有購買servicePriceGroup -> 則spa要關掉
     */
    async filterTabList() {
      const { plan } = await getSavedState('merchant.cached')
      if (plan) {
        let permissionPriceGroup = plan.additionalModules.findIndex((item) => item === 'servicePriceGroup')
        if (permissionPriceGroup === -1) {
          this.tabList = this.tabList.filter((item) => item.type !== 'spa')
        }
      }
    },
    onFilterReset() {
      this.filterData = {
        state: '',
        productId: '',
      }
      this.tryToFetchList()
    },
    updateMode(mode) {
      this.mode = mode
    },
    changeTitle() {
      this.$route.meta.title = this.pageTitle
    },
    async updateCategory() {
      this.category = await this.$store.dispatch('product/fetchServiceCategory')
    },
  },
  mounted() { },
}
</script>

<style lang="scss" module>

.table {
  @include layer-elevation(5);
}

.marginContent {
  margin: 20px;
}

:global {
  .isEdit {
    .el-tabs__header {
      display: none;
    }

    &.el-tabs--border-card {
      border-radius: 0;
      background: none;
      box-shadow: none;

      .el-tabs__content {
        padding: 0;
      }
    }
  }
}
</style>
